<template>
    <div class="container">
        <AudioIcon />
        <div class="container-text">
            <p>{{ text }}</p>
            <img class="forward" src="@game/assets/img/arrow.png" alt="" @click="onForward">
        </div>
    </div>
</template>

<script>
import { tLevel4 } from '@game/utils';
import { audioMixinLevel41 } from '@game/mixins/audioMixin.js';

export default {
    name: 'Scene1',
    mixins: [audioMixinLevel41],
    data() {
        return {
            text: tLevel4('scene1.shylock')
        }
    },
    methods: {
        onForward() {
            this.$audioManager.playButtonNext(() => {
                this.$router.push({ name: 'L4Scene2' })
            })
        }
    }
}

</script>

<style lang="scss" scoped>
.container {
    background-image: url(@game/Level04/assets/img/shylock.jpg);
    .container-text {
        min-height: 15%;
    }
}

</style>